import { io } from 'socket.io-client';
import API_URL from '../apiconfig';
import { auth } from '../firebase';

export const socket = io(API_URL, {
  transports: ['websocket', 'polling'], // use WebSocket first, if available
  // Re-evaluated on every connection attempt, so reconnects always carry a
  // fresh Firebase ID token. The server verifies it on 'register'.
  auth: async cb => {
    const token = await auth.currentUser?.getIdToken().catch(() => undefined);
    cb(token ? { token } : {});
  },
});
